package com.fireavert.react.pages.administration.breadcrumbs.users.dialogs

import com.fireavert.react.shared.components.custom_icons.WarningIcon
import com.fireavert.react.shared.styles.DialogStyles
import emotion.css.ClassName
import emotion.css.cx
import emotion.react.css
import mui.material.*
import mui.system.Breakpoint
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.useState
import web.cssom.JustifyContent
import web.cssom.NamedColor
import web.cssom.important
import web.cssom.px

external interface DeleteUserDialogProps : Props {
    var closeDialog : () -> Unit
    var success: Boolean
    var eraseUser: (Boolean) -> Unit
}

val DeleteUserDialog = FC<DeleteUserDialogProps> { props ->

    var confirmed by useState(false)
    Dialog {
        open = true
        onBackdropClick = { props.closeDialog() }
        onClose = { _, _ -> props.closeDialog() }
        maxWidth = Breakpoint.lg
        if (!confirmed) {
            DialogContent {
                className = DialogStyles.warningDialogContent
                WarningIcon {}
                div {
                    className = DialogStyles.warningTitle
                    +"WARNING"
                }
                div {
                    className = cx(DialogStyles.warningText, ClassName {
                        marginBottom = 20.px
                    })
                    +"THIS ACTION IS NOT REVERSIBLE, IT WILL PERMANENTLY DELETE THIS USER"
                }
                div {
                    className = DialogStyles.warningText
                    +"Are you sure that you would lke to delete this user?"
                }
                DialogActions {
                    css {
                        height = 104.px
                        padding = 24.px
                        justifyContent = important(JustifyContent.center)
                    }
                    Button {
                        +"No, keep them as a user"
                        color = ButtonColor.inherit
                        onClick = {  }
                        variant = ButtonVariant.contained
                        css {
                            width = 400.px
                            marginRight = 6.px
                            backgroundColor = NamedColor.white
                        }
                    }
                    Button {
                        +"Yes, delete them"
                        color = ButtonColor.inherit
                        onClick = {
                            confirmed = true
                            props.eraseUser(true)
                        }
                        variant = ButtonVariant.contained
                        css {
                            width = 400.px
                            backgroundColor = NamedColor.white
                        }
                    }
                }
            }
        } else {
            DialogTitle {
                className = DialogStyles.dialogTitle
                +"Reboot Device"
            }
            DialogContent {
                className = DialogStyles.warningDialogContent
                div {
                    className = DialogStyles.warningText
                    if (props.success) {
                        +"Delete Request was made successfully"
                    } else {
                        +"There was an error when deleting the user, please try again"
                    }
                }
                DialogActions {
                    css {
                        height = 104.px
                        justifyContent = important(JustifyContent.center)
                    }
                    Button {
                        +"OK"
                        color = ButtonColor.inherit
                        onClick = {
                            props.closeDialog()
                        }
                        variant = ButtonVariant.contained
                        css {
                            width = 163.px
                        }
                    }
                }
            }
        }
    }
}